<template>
<div class="chapter">
<div class="inner_page">
<div id="fm7">
<p style="text-align: center">It does not follow that because a mountain appears to take on different shapes from different angles of vision, it has objectively no shape at all or an infinity of shapes.</p>
<p style="text-align: center; margin-top: .8em;">E. H. CARR</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// other.vue?3143205a